import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as displayDependent from './scripts/display-dependent';
displayDependent.init();

import * as numberSpinner from './scripts/number-spinner';
numberSpinner.init();

import * as checkoutCountryInfo from './scripts/checkout-country-info';
checkoutCountryInfo.init();
